import CrmConfigurationService from "@/services/api/crmConfiguration";
import { handleResponse } from "@/services/axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const addCustomerConfigurationField = createAsyncThunk(
  "crmConfiguration/addCustomerConfigurationField",
  async (data: any, { rejectWithValue }) => {
    try {
      const response =
        await CrmConfigurationService.addCustomerConfigurationField(data);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.Message || "Failed to add customer configuration field",
      );
    }
  },
);

export const fetchCrmCustomerConfiguration = createAsyncThunk(
  "crmConfiguration/fetchCrmCustomerConfiguration",
  async (_, { rejectWithValue }) => {
    try {
      const response =
        await CrmConfigurationService.fetchCustomerConfigurationFields();
      return handleResponse(response, rejectWithValue);
    } catch (error: any) {
      return rejectWithValue(
        error?.Message ?? "Failed to fetch crm customer configuration fields",
      );
    }
  },
);

export const updateCustomerConfigurationCustomFields = createAsyncThunk(
  "crmConfiguration/updateCustomerConfigurationCustomFields",
  async (payload: any, { rejectWithValue }) => {
    try {
      const res =
        await CrmConfigurationService.updateCustomerConfigurationCustomFields(
          payload,
        );
      return handleResponse(res, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.Message);
    }
  },
);

export const getCustomerConfigurationFieldSetting = createAsyncThunk(
  "crmConfiguration/getCustomerConfigurationFieldSetting",
  async (_, { rejectWithValue }) => {
    try {
      const res = await CrmConfigurationService.getCustomerConfigurationFieldSetting();
      return handleResponse(res, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data?.Message ?? "Failed to fetch customer configuration field setting");
    }
  },
);

export const updateCustomerConfigurationFieldSetting = createAsyncThunk(
  "crmConfiguration/updateCustomerConfigurationFieldSetting",
  async (payload: any, { rejectWithValue }) => {
    try {
      const res = await CrmConfigurationService.updateCustomerConfigurationFieldSetting(payload);
      return handleResponse(res, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data?.Message ?? "Failed to update customer configuration field setting");
    }
  },
);

const initialState = {
  customerConfigurationFields: [],
  customerConfigurationFieldSetting: [],
};

const crmConfigurationSlice = createSlice({
  name: "crmConfiguration",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(
      fetchCrmCustomerConfiguration.fulfilled,
      (state, action) => {
        state.customerConfigurationFields = action.payload;
      },
    );
    builder.addCase(
      getCustomerConfigurationFieldSetting.fulfilled,
      (state, action) => {
        state.customerConfigurationFieldSetting = action.payload;
      },
    );
  },
});

export default crmConfigurationSlice.reducer;
